import React, { useEffect, useState } from "react";

import { Form, Radio, Divider, Input, Row, Col, RadioChangeEvent, FormInstance} from 'antd';
import { ContainerForm, TextDivider } from "./styles";
import ScheduleData from "../../models/ScheduleData";
import Vehicle from "../../models/Vehicle";
import { AppRadio } from "../../global/styles";
import {maskChassi} from "../../utils/StringUtils";

interface VehiclesProps {
    scheduleVehicleData: ScheduleData,
    setVehicleData: any,
    formRef: FormInstance,
    secondaryColor: string
}

const Vehicles: React.FC<VehiclesProps> = ({ scheduleVehicleData, setVehicleData, formRef, secondaryColor, ...rest }: VehiclesProps) => {

    const [localVehicleData, setLocalVehicleData] = useState<Vehicle>();

    const onChangeVehicle = ((e:RadioChangeEvent) => {
        let vehicle = scheduleVehicleData.vehicleResponseDtoList.filter((vehicle) => vehicle.vehicleChassi === e.target.value)[0];
        setVehicleData(vehicle);        
        setLocalVehicleData(vehicle);
    });

    useEffect(() => {
        if (localVehicleData?.vehicleChassi) {
            formRef.setFieldsValue({
                vehicleChassis: maskChassi(localVehicleData.vehicleChassi) // Aplica a máscara antes de definir o valor
            });
        }
    }, [localVehicleData, formRef]);


    return (
        <ContainerForm>
            <Divider orientation="center" plain><TextDivider> Qual o chassi correspondente ao veículo que deseja agendar? </TextDivider></Divider>
            <Form form={formRef} >                
                <Form.Item name="vehiclePlateChassi" rules={[{ required: true, message: 'Selecione um veículo' }]}>
                    <Radio.Group onChange={onChangeVehicle}>
                        {scheduleVehicleData.vehicleResponseDtoList.map((vehicle, key) => (
                            <AppRadio color={"#DC3644"} value={vehicle.vehicleChassi} key={key}>
                                {vehicle.vehiclePlate ? vehicle.vehiclePlate : maskChassi(vehicle.vehicleChassi)}
                            </AppRadio>
                        ))}
                    </Radio.Group>
                </Form.Item>
            </Form>
            <Divider orientation="center" plain><TextDivider> Dados Veiculo </TextDivider></Divider>

            <Form form={formRef} >
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" xl={8} xs={24} sm={12}>
                        <Form.Item label="Chassi" name="vehicleChassis">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" xl={8} xs={24} sm={12}>
                        <Form.Item label="Fabricante">
                            <Input value={localVehicleData?.vehicleManufacturerName} disabled={true} />
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" xl={8} xs={24} sm={24}>
                        <Form.Item label="Modelo">
                            <Input value={localVehicleData?.vehicleModelName} disabled={true} />
                        </Form.Item>
                    </Col>                    
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" xl={8} xs={12} sm={8}>
                        <Form.Item label="Ano">
                            <Input value={localVehicleData?.vehicleYear} disabled={true} />
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" xl={8} xs={12} sm={8}>
                        <Form.Item label="Cor">
                            <Input value={localVehicleData?.vehicleColorName} disabled={true} />
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" xl={8} xs={24} sm={8}>
                        <Form.Item label="Tipo Veiculo">
                            <Input value={localVehicleData?.vehicleTypeName} disabled={true} />
                        </Form.Item>
                    </Col>
                   
                </Row>
               
            </Form>
        </ContainerForm>
    )
}

export default Vehicles;